/**
 * iurop-sliders.js — mecánica compartida de sliders (engine iUROP).
 * Sirve para cualquier sección con [data-product-slider] que contenga:
 *  - [data-slider-track]: fila con scroll horizontal + snap (CSS).
 *  - [data-slider-prev]/[data-slider-next]: flechas (escritorio).
 *  - [data-slider-dots]: contenedor de puntitos (móvil, Figma Home-Mobile);
 *    se generan aquí, uno por slide, y se sincronizan con el scroll.
 * Todo por delegación: funciona con varias instancias y con la recarga
 * de secciones del editor.
 */
(function () {
  'use strict';

  // El script se incluye en varias secciones (slider, testimonios, UGC,
  // need-banners); los <script src> clásicos NO se deduplican, así que el IIFE
  // se ejecutaría una vez por sección y duplicaría los listeners globales (las
  // flechas saltaban N tarjetas). Todo funciona por delegación en document, así
  // que basta con registrar una sola vez.
  if (window.__iuropSliderInit) return;
  window.__iuropSliderInit = true;

  function getStep(track) {
    var slide = track.firstElementChild;
    var styles = getComputedStyle(track);
    var gap = parseFloat(styles.columnGap || styles.gap) || 0;
    return slide ? slide.getBoundingClientRect().width + gap : track.clientWidth;
  }

  function updateArrows(section) {
    if (!section) return;
    var track = section.querySelector('[data-slider-track]');
    var prev = section.querySelector('[data-slider-prev]');
    var next = section.querySelector('[data-slider-next]');
    if (!track) return;
    var max = track.scrollWidth - track.clientWidth - 1;
    if (prev) prev.disabled = track.scrollLeft <= 0;
    if (next) next.disabled = track.scrollLeft >= max;
  }

  function buildDots(section) {
    var wrap = section.querySelector('[data-slider-dots]');
    var track = section.querySelector('[data-slider-track]');
    if (!wrap || !track) return;
    var count = track.children.length;
    if (wrap.childElementCount !== count) {
      wrap.innerHTML = '';
      for (var i = 0; i < count; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'iurop-slider-dot';
        dot.setAttribute('data-slider-dot', String(i));
        dot.setAttribute('aria-label', (i + 1) + ' / ' + count);
        wrap.appendChild(dot);
      }
    }
    updateDots(section);
  }

  function updateDots(section) {
    if (!section) return;
    var wrap = section.querySelector('[data-slider-dots]');
    var track = section.querySelector('[data-slider-track]');
    if (!wrap || !track || !wrap.childElementCount) return;
    // QA 17-jul: el punto activo = TARJETA más cercana al centro de la vista
    // (con el mapeo por progreso los puntos intermedios eran inalcanzables en
    // algunos anchos y el del medio "no se dejaba" activar). Extremos clavados:
    // al principio siempre el 1º, al final siempre el último.
    var count = wrap.childElementCount;
    var max = track.scrollWidth - track.clientWidth;
    var idx = 0;
    if (track.scrollLeft <= 1) {
      idx = 0;
    } else if (track.scrollLeft >= max - 1) {
      idx = count - 1;
    } else {
      var center = track.scrollLeft + track.clientWidth / 2;
      var best = Infinity;
      Array.prototype.forEach.call(track.children, function (child, i) {
        var c = child.offsetLeft + child.offsetWidth / 2;
        var d = Math.abs(c - center);
        if (d < best) { best = d; idx = i; }
      });
    }
    idx = Math.max(0, Math.min(idx, count - 1));
    Array.prototype.forEach.call(wrap.children, function (dot, i) {
      dot.classList.toggle('is-active', i === idx);
    });
  }

  document.addEventListener('click', function (event) {
    var arrow = event.target.closest('[data-slider-prev], [data-slider-next]');
    if (arrow) {
      var section = arrow.closest('[data-product-slider]');
      var track = section && section.querySelector('[data-slider-track]');
      if (!track) return;
      var dir = arrow.hasAttribute('data-slider-prev') ? -1 : 1;
      track.scrollBy({ left: dir * getStep(track), behavior: 'smooth' });
      return;
    }

    var dot = event.target.closest('[data-slider-dot]');
    if (dot) {
      var dotSection = dot.closest('[data-product-slider]');
      var dotTrack = dotSection && dotSection.querySelector('[data-slider-track]');
      if (!dotTrack) return;
      var i = parseInt(dot.getAttribute('data-slider-dot'), 10) || 0;
      var dotCount = dotSection.querySelectorAll('[data-slider-dot]').length;
      var dotMax = dotTrack.scrollWidth - dotTrack.clientWidth;
      var left = dotCount > 1 ? (i / (dotCount - 1)) * dotMax : 0;
      dotTrack.scrollTo({ left: left, behavior: 'smooth' });
    }
  });

  // Estado de flechas y puntitos al hacer scroll (captura: scroll no burbujea)
  document.addEventListener(
    'scroll',
    function (event) {
      var el = event.target;
      if (el.nodeType === 1 && el.hasAttribute && el.hasAttribute('data-slider-track')) {
        var section = el.closest('[data-product-slider]');
        updateArrows(section);
        updateDots(section);
      }
    },
    true
  );

  function initAll() {
    document.querySelectorAll('[data-product-slider]').forEach(function (section) {
      updateArrows(section);
      buildDots(section);
    });
  }

  // Recomendaciones (Search & Discovery): los tracks con data-recommendations
  // piden a Shopify los productos related/complementary del producto visto y
  // sustituyen el track. Si la API no devuelve nada, se queda la colección de
  // respaldo ya renderizada.
  function loadRecommendations() {
    var base = (window.routes && window.routes.product_recommendations_url) || '/recommendations/products';
    document.querySelectorAll('[data-slider-track][data-recommendations]').forEach(function (track) {
      var pid = track.getAttribute('data-product-id');
      var sid = track.getAttribute('data-section-id');
      if (!pid || !sid || track.dataset.recoDone) return;
      track.dataset.recoDone = '1';
      var url = base + '?section_id=' + encodeURIComponent(sid) +
        '&product_id=' + encodeURIComponent(pid) +
        '&intent=' + encodeURIComponent(track.getAttribute('data-intent') || 'related') +
        '&limit=' + encodeURIComponent(track.getAttribute('data-limit') || 10);
      fetch(url, { headers: { Accept: 'text/html' } })
        .then(function (r) { return r.ok ? r.text() : null; })
        .then(function (html) {
          if (!html) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var newTrack = doc.querySelector('[data-slider-track]');
          if (newTrack && newTrack.querySelector('.iurop-product-slider__slide')) {
            track.innerHTML = newTrack.innerHTML;
            document.dispatchEvent(new CustomEvent('shopify:section:load'));
          }
        })
        .catch(function () {});
    });
  }

  window.addEventListener('resize', initAll);
  document.addEventListener('shopify:section:load', initAll);
  if (document.readyState !== 'loading') {
    initAll();
    loadRecommendations();
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      initAll();
      loadRecommendations();
    });
  }
})();

// v-bump 17-jul dots-fix
